import { render, staticRenderFns } from "./MultipleTextInput.vue?vue&type=template&id=a454ca46&scoped=true&"
import script from "./MultipleTextInput.vue?vue&type=script&lang=ts&"
export * from "./MultipleTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleTextInput.vue?vue&type=style&index=0&id=a454ca46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a454ca46",
  null
  
)

export default component.exports